const sidebarNavT = [
	{
		link: '/dashboard',
		section: 'dashboard',
		icon: <i class='fa-solid fa-house'></i>,
		text: 'Home',
	},

	{
		link: '/editprofile',
		section: 'editprofile',
		icon: <i class='fa-solid fa-user-pen'></i>,
		text: 'EditProfile',
	},
	{
		link: '/changepassword',
		section: 'changepassword',
		icon: <i class='fa-solid fa-key'></i>,
		text: 'ChangePassword',
	},
	// {
	// 	link: '/managemarkup',
	// 	section: 'managemarkup',
	// 	icon: <i class='fa-solid fa-wand-magic-sparkles'></i>,
	// 	text: 'ManageMarkup',
	// },
	{
		link: '/bookhistory',
		section: 'bookhistory',
		icon: <i class='fa-solid fa-briefcase'></i>,
		text: 'Booking History',
	},
	// {
	// 	link: '/transactionhistory',
	// 	section: 'transactionhistory',
	// 	icon: <i class='fa-solid fa-briefcase'></i>,
	// 	text: 'Transaction History',
	// },
	{
		link: '/bank',
		section: 'bank',
		icon: <i class='fa-solid fa-building-columns'></i>,
		text: 'BankDetails',
	},
];

export default sidebarNavT;
